'use client'

// PondArea — the wooden jetty on the lake's north-west shore. Pure
// scenery: no entity, no mechanics. The pond's actual behaviour lives on
// activity_pond a few units east, and the octopus sits further out again.
//
// Was a whole dressing set (jetty + rocks + reeds); Sam cut it back to
// the jetty alone, so the rocks, the plants and BOTH textures came out of
// the GLB with them. What is left has no texture at all, just three
// colour-factor materials, which is why there is no KTX2 here and no
// instancing either: 431KB of source is now 8.3KB.
//
// Transform is baked (the export carries its world position) and the node
// is scaled 1.2 in the file, so this drops in at identity.

import { useEffect } from 'react'
import * as THREE from 'three/webgpu'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/pondArea.glb'

export function PondArea() {
  const { scene } = useModel(MODEL)

  useEffect(() => {
    // Same conversion as every other baked prop: a fresh
    // MeshStandardNodeMaterial with slots set EXPLICITLY (never copy(),
    // which drops undefined into the node slots and kills the shader), so
    // the jetty lights, shadows and dithers with the rest of the world.
    const converted = new Map()
    scene.traverse((o) => {
      if (!o.isMesh) return
      o.castShadow = true
      o.receiveShadow = true
      const src = o.material
      if (!src || Array.isArray(src) || src.isNodeMaterial) return
      let nm = converted.get(src)
      if (!nm) {
        nm = new THREE.MeshStandardNodeMaterial()
        if (src.map) nm.map = src.map
        nm.color = src.color?.clone() ?? new THREE.Color('white')
        nm.roughness = src.roughness ?? 0.9
        nm.metalness = src.metalness ?? 0
        nm.side = src.side
        nm.vertexColors = src.vertexColors
        converted.set(src, nm)
      }
      o.material = nm
    })
  }, [scene])

  // Transform is baked into the node — render at identity.
  return <primitive object={scene} />
}

export default PondArea
